import { useMutation } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { CustomersApi } from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";

interface UseCustomerCreateParams {
  userId: number;
  tenantId: number;
}

export const useCustomerCreate = () => {
  const accessToken = useAccessToken();

  const { mutate, mutateAsync, isPending, isSuccess, isError, error } =
    useMutation({
      mutationFn: async ({ userId, tenantId }: UseCustomerCreateParams) => {
        if (!accessToken) {
          throw new Error("Authentication token is required");
        }

        const service = createAuthenticatedApi(CustomersApi, accessToken);

        await service.apiUsersUserIdCustomerPost({
          userId,
          xTenantID: tenantId,
        });

        return { userId, tenantId };
      },
    });

  return { mutate, mutateAsync, isPending, isSuccess, isError, error };
};
